import { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { requestCustomerLogin, useCustomer } from 'lib/customer'
import { useRouter } from 'next/router'
import { useAppStore } from 'lib/hooks/useAppStore'

import { Button } from 'components/Global/Button'
import { Input } from './Input'

export const Login = () => {
  const { setAccountModal } = useAppStore()
  const [error, setError] = useState<string | null>()
  const { register, handleSubmit } = useForm<{
    email: string
    password: string
  }>()
  const { data: customer } = useCustomer()
  const router = useRouter()

  useEffect(() => {
    if (customer !== null) {
      router.push('/account')
      return
    }
  }, [customer])

  const onSubmit = handleSubmit(async (formData, event) => {
    try {
      await requestCustomerLogin(formData)
      router.push('/account', undefined, { scroll: false })
      setAccountModal(false)
    } catch (error) {
      if (error.code === 'UNIDENTIFIED_CUSTOMER') {
        setError('Invalid email or password.')
      } else {
        setError(error.message)
      }
    }
  })

  return (
    <form
      method="POST"
      action="https://chnge-nyc.myshopify.com/account/login"
      className="flex w-full flex-col gap-10"
      onSubmit={onSubmit}
    >
      <Input id="email" type="email" label="Email" register={register} />
      <Input
        id="password"
        type="password"
        label="Password"
        register={register}
      />
      <div className="flex gap-16">
        <Button
          as="link"
          href="#"
          className="flex-1 bg-black py-20 text-center text-12 text-white md:py-26 md:text-16 md:hover:!bg-darkerGray"
          type="button"
        >
          Forgot Password
        </Button>
        <Button
          className="flex-1 bg-yellow py-20 text-12 md:py-26 md:text-16 md:hover:bg-yellow"
          type="submit"
        >
          Submit
        </Button>
      </div>
      {error ? (
        <p className="max-w-[500px] pt-10 text-12 text-midGray">{error}</p>
      ) : null}
    </form>
  )
}
